export function ManageSQLQueryCtrl ($scope, $window, API, workshopAPI, messages) {

  $scope.query = ''

  $scope.runQuery = function () {
    var sql_log = {
      company_id : $scope.company.id ,
      sql_query : $scope.query
    }
    workshopAPI.post('/support_sql_query_logs', sql_log, 'support_sql_query_log').then(function (query) {
      $window.open(`${API.url}/workshop_admin/support_sql_query/${$scope.company.id}/${query.id}`);
    }, function (err) {
      messages.error(err);
    })
        
  };
}